/** Public build-time configuration (all values are safe to ship in the browser bundle). */
export const env = {
  supabaseUrl: (import.meta.env.VITE_SUPABASE_URL as string | undefined) ?? '',
  supabaseAnonKey: (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ?? '',
  googleClientId: (import.meta.env.VITE_GOOGLE_CLIENT_ID as string | undefined) ?? '',
  vapidPublicKey: (import.meta.env.VITE_VAPID_PUBLIC_KEY as string | undefined) ?? '',
  appUrl: (import.meta.env.VITE_APP_URL as string | undefined) ?? window.location.origin,
};

/** True when the app was built with Supabase settings; otherwise it runs in local demo mode. */
export const hasBackend = Boolean(env.supabaseUrl && env.supabaseAnonKey);
